import { SummaryFeatureMapItem } from '~pricing/lib/summaryPackages';

// The list of the order in which summary display features should be shown.
// Also maps where feature set items should be combined or split for display purposes
// To make TS happy we still have to map standalone features to an empty array
const DefaultFeatureSetToSummaryFeatures: SummaryFeatureMapItem[] = [
  {
    featureItemKey: 'survey_create_limit',
  },
  {
    featureItemKey: 'create_question_limit',
  },
  {
    featureItemKey: 'response_count',
    features: ['base_response_count', 'num_free_responses'],
  },
  {
    featureItemKey: 'support',
    features: ['email_support', 'priority_email_support', 'phone_support'],
  },
  {
    featureItemKey: 'quizzes_pro',
  },
  {
    featureItemKey: 'analyze_export_enabled',
  },
  {
    featureItemKey: 'survey_logic',
    features: ['create_skip_logic_enabled', 'create_piping_enabled'],
  },
  {
    featureItemKey: 'statistical_significance',
  },
  {
    featureItemKey: 'analyze_export_spss_enabled',
  },
  {
    featureItemKey: 'survey_branding',
    features: ['create_logo_enabled', 'create_custom_theme_enabled', 'collector_friendly_url_enabled'],
  },
  {
    featureItemKey: 'create_advanced_features',
    features: ['create_quotas_enabled', 'a_b_testing', 'create_randomization_enabled'],
  },
  {
    featureItemKey: 'create_custom_variables_enabled',
  },
  {
    featureItemKey: 'payment_qt',
  },
  {
    featureItemKey: 'file_upload',
  },
  {
    featureItemKey: 'benchmarks',
  },
  {
    featureItemKey: 'click_map_qt',
  },
];

export default DefaultFeatureSetToSummaryFeatures;
